import { createTRPCReact } from '@trpc/react-query'

import type { AppRouter } from '@rescuebase/api/client-types'

export default createTRPCReact<AppRouter>()
